

/**
 * @deprecated remove in favor of components/spinner/index.vue
 */
export default {
  props: {
    spinnerMessage: {
      type: String,
      default: null,
    },
  },
};
